import React from 'react';

export const BillboardSkeleton = () => (
  <div className='absolute inset-0 animate-pulse overflow-hidden bg-gray-200'>
    <div className='absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200' />
    <div className='absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-gray-300/70 to-transparent' />
    <div className='absolute left-1/2 top-1/2 h-[72%] w-[72%] -translate-x-1/2 -translate-y-1/2 rounded-[2rem] bg-white/20' />
  </div>
);
